"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
const repertoire = [{
  title: "Superstition",
  artist: "Stevie Wonder",
  category: "Motown"
}, {
  title: "Let's Stay Together",
  artist: "Al Green",
  category: "Motown"
}, {
  title: "Ain't No Mountain High Enough",
  artist: "Marvin Gaye & Tammi Terrell",
  category: "Motown"
}, {
  title: "My Girl",
  artist: "The Temptations",
  category: "Motown"
}, {
  title: "Signed, Sealed, Delivered",
  artist: "Stevie Wonder",
  category: "Motown"
}, {
  title: "Respect",
  artist: "Aretha Franklin",
  category: "Motown"
}, {
  title: "Waterfalls",
  artist: "TLC",
  category: "90s R&B"
}, {
  title: "No Diggity",
  artist: "Blackstreet",
  category: "90s R&B"
}, {
  title: "Kiss",
  artist: "Prince",
  category: "80s R&B"
}, {
  title: "Fantasy",
  artist: "Mariah Carey",
  category: "90s R&B"
}, {
  title: "Poison",
  artist: "Bell Biv DeVoe",
  category: "90s R&B"
}, {
  title: "Return of the Mack",
  artist: "Mark Morrison",
  category: "90s R&B"
}, {
  title: "Valerie",
  artist: "Amy Winehouse",
  category: "Modern Classics"
}, {
  title: "Uptown Funk",
  artist: "Mark Ronson ft. Bruno Mars",
  category: "Modern Classics"
}, {
  title: "Leave The Door Open",
  artist: "Silk Sonic",
  category: "Modern Classics"
}, {
  title: "Crazy In Love",
  artist: "Beyoncé",
  category: "Modern Classics"
}, {
  title: "Get Lucky",
  artist: "Daft Punk",
  category: "Modern Classics"
}, {
  title: "Treasure",
  artist: "Bruno Mars",
  category: "Modern Classics"
}, {
  title: "Take Five",
  artist: "Dave Brubeck",
  category: "Jazz"
}, {
  title: "So What",
  artist: "Miles Davis",
  category: "Jazz"
}, {
  title: "Shape of You",
  artist: "Ed Sheeran",
  category: "Pop"
}, {
  title: "Breezin",
  artist: "George Benson",
  category: "Smooth Jazz"
}];
const categories = ["All", "Motown", "90s R&B", "Modern Classics", "Jazz", "Pop", "Smooth Jazz"];
export default function ATimelessRepertoire() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="a-timeless-repertoire" className="dark bg-background text-foreground py-24 md:py-32 px-6 md:px-12 overflow-hidden relative">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-full max-h-[600px] bg-secondary/5 blur-[120px] rounded-full pointer-events-none -z-10" />

      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="text-center mb-16 space-y-4">
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-foreground font-light tracking-tight">
            A Timeless Repertoire
          </h2>
          <p className="font-sans text-muted-foreground max-w-2xl mx-auto text-lg">
            Curated selections spanning decades of soul, rhythm, and timeless energy.
          </p>
        </div>

        <Tabs defaultValue="All" className="w-full">
          <div className="flex justify-center mb-16">
            <TabsList className="bg-transparent border border-secondary/20 p-1 h-auto rounded-lg flex-wrap justify-center gap-1">
              {categories.map((category, index) => <TabsTrigger key={category} value={category} data-index={index} className="rounded-md px-6 py-2.5 text-sm md:text-base data-[state=active]:bg-secondary/10 data-[state=active]:text-secondary data-[state=active]:border-secondary/30 border border-transparent transition-all">
                  {category}
                </TabsTrigger>)}
            </TabsList>
          </div>

          {categories.map((category, index) => {
          const filteredSongs = category === "All" ? repertoire : repertoire.filter(song => song.category === category);
          const itemsPerColumn = Math.ceil(filteredSongs.length / 3);
          const col1 = filteredSongs.slice(0, itemsPerColumn);
          const col2 = filteredSongs.slice(itemsPerColumn, itemsPerColumn * 2);
          const col3 = filteredSongs.slice(itemsPerColumn * 2);
          return <TabsContent key={category} value={category} data-index={index} className="mt-0 focus-visible:outline-none focus-visible:ring-0">
                <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-secondary/20">
                  {}
                  <div className="flex flex-col gap-8 py-8 md:py-0 md:pr-12">
                    {col1.map((song, i) => <div key={song.title} data-index={i} className="group">
                        <h3 className="font-serif text-xl md:text-2xl text-foreground font-light transition-colors group-hover:text-secondary">
                          {song.title}
                        </h3>
                        <p className="font-sans text-xs md:text-sm tracking-widest uppercase text-secondary mt-2">
                          {song.artist}
                        </p>
                      </div>)}
                  </div>

                  {}
                  <div className="flex flex-col gap-8 py-8 md:py-0 md:px-12">
                    {col2.map((song, i) => <div key={song.title} data-index={i} className="group">
                        <h3 className="font-serif text-xl md:text-2xl text-foreground font-light transition-colors group-hover:text-secondary">
                          {song.title}
                        </h3>
                        <p className="font-sans text-xs md:text-sm tracking-widest uppercase text-secondary mt-2">
                          {song.artist}
                        </p>
                      </div>)}
                  </div>

                  {}
                  <div className="flex flex-col gap-8 py-8 md:py-0 md:pl-12">
                    {col3.map((song, i) => <div key={song.title} data-index={i} className="group">
                        <h3 className="font-serif text-xl md:text-2xl text-foreground font-light transition-colors group-hover:text-secondary">
                          {song.title}
                        </h3>
                        <p className="font-sans text-xs md:text-sm tracking-widest uppercase text-secondary mt-2">
                          {song.artist}
                        </p>
                      </div>)}
                  </div>
                </div>
              </TabsContent>;
        })}
        </Tabs>
      </div>
    </section>;
}